import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	exceedWarningLabel: {
		id: 'polaris-ideas.idea-view.attachments.exceed-warning.exceed-warning-label',
		defaultMessage: 'This idea has too many attachments. Thumbnails and previews won’t load.',
		description: 'The warning label on attachment panel when user is exceeding the limit',
	},
});
